module.exports = __webpack_public_path__ + "img/cropped-rylan-hill-pf-eZzTvVzk-unsplash-compressed-mobile.95a3ecb5.webp";